// extracted by mini-css-extract-plugin
export default {"cardList":"style_cardList__TPDev","card":"style_card__Ducvz","icon":"style_icon__td3I7","cardTitle":"style_cardTitle__eAEy2","cardDescription":"style_cardDescription__D5eFu"};